import React from 'react';
import { AttachmentContextTrigger } from '../shared';
import { UserAvatar } from '../../../shared/UserAvatar';

export const TaskFollowSection = ({
    followComposerSectionRef,
    composerMode,
    setComposerMode,
    followIsPublic,
    setFollowIsPublic,
    followEditorRef,
    handleFollowEditorInput,
    followFilesInputRef,
    handleFollowAttachmentsChange,
    handleOpenFollowFilesPicker,
    handleCreateFollow,
    isSavingFollow,
    isResolving,
    followAttachments,
    activeFollowTab,
    setActiveFollowTab,
    sortedFollows,
    publicFollows,
    privateFollows,
    followSortMenuRef,
    isFollowSortMenuOpen,
    setIsFollowSortMenuOpen,
    followSortOrder,
    handleSelectFollowSortOrder,
    resolutionAttachments,
    openAttachmentMenuId,
    handleToggleAttachmentMenu,
    handleDownloadAttachment,
    visibleFollows,
    followEmptyMessage,
    followFilesById,
    formatDateTime,
    getFollowAuthorAvatar,
}) => {
    return (
        <div className="card card__no-border mt-3" ref={followComposerSectionRef}>
            <div className="card-body p-0">
                <h6 className="fw-semibold mb-3">Seguimientos / Resolución</h6>

                {composerMode === 'resolution' && (
                    <div className="alert alert-warning py-2 d-flex justify-content-between align-items-center mb-3" role="alert">
                        <span>Modo resolución activo: este contenido se guardará como seguimiento y resolución del ticket.</span>
                        <button
                            type="button"
                            className="btn btn-sm btn-light"
                            onClick={() => setComposerMode('follow')}
                        >
                            Cancelar
                        </button>
                    </div>
                )}

                <div className="border rounded p-3 mb-3 bg-light">
                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2">
                        <label className="form-label mb-0">{composerMode === 'resolution' ? 'Resolución' : 'Nuevo seguimiento'}</label>

                        {composerMode !== 'resolution' ? (
                            <div className="d-flex align-items-center gap-2">
                                <span className={`badge ${followIsPublic ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'}`}>
                                    {followIsPublic ? 'PÚBLICO' : 'PRIVADO'}
                                </span>
                                <div className="form-check form-switch m-0">
                                    <input
                                        type="checkbox"
                                        className="form-check-input"
                                        id="follow-public-flag"
                                        checked={followIsPublic}
                                        onChange={(event) => setFollowIsPublic(event.target.checked)}
                                    />
                                </div>
                            </div>
                        ) : (
                            <span className="badge bg-soft-info text-info">RESOLUCIÓN</span>
                        )}
                    </div>

                    <div ref={followEditorRef} className="form-control" contentEditable suppressContentEditableWarning onInput={handleFollowEditorInput} style={{ minHeight: '140px', overflowY: 'auto' }} />

                    <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mt-2">
                        <div className="ticket-file-input">
                            <input
                                ref={followFilesInputRef}
                                type="file"
                                className="ticket-file-input__native"
                                multiple
                                onChange={handleFollowAttachmentsChange}
                            />
                            <button
                                type="button"
                                className="ticket-file-input__trigger"
                                onClick={handleOpenFollowFilesPicker}
                            >
                                <i className="bi bi-paperclip" aria-hidden="true" />
                                Adjuntar archivos
                            </button>
                        </div>

                        <button type="button" className="btn btn-primary " onClick={handleCreateFollow} disabled={isSavingFollow || isResolving}>
                            {(isSavingFollow || isResolving)
                                ? 'Guardando...'
                                : (composerMode === 'resolution' ? 'Confirmar resolución' : 'Enviar')}
                        </button>
                    </div>

                    {followAttachments.length > 0 && (
                        <div className="mt-2 text-muted fs-12">{followAttachments.map((file) => file.name).join(' · ')}</div>
                    )}
                </div>

                <div className="ticket-follows-panel">
                    <div className="ticket-follows-panel__toolbar">
                        <div className="ticket-follows-panel__tabs">
                            <button
                                type="button"
                                className={`ticket-follows-panel__tab ${activeFollowTab === 'all' ? 'is-active' : ''}`}
                                onClick={() => setActiveFollowTab('all')}
                            >
                                Conversación ({sortedFollows.length})
                            </button>
                            <button
                                type="button"
                                className={`ticket-follows-panel__tab ${activeFollowTab === 'public' ? 'is-active' : ''}`}
                                onClick={() => setActiveFollowTab('public')}
                            >
                                Públicas ({publicFollows.length})
                            </button>
                            <button
                                type="button"
                                className={`ticket-follows-panel__tab ${activeFollowTab === 'private' ? 'is-active' : ''}`}
                                onClick={() => setActiveFollowTab('private')}
                            >
                                Privadas ({privateFollows.length})
                            </button>
                        </div>

                        <div className="ticket-follows-panel__actions">
                            <div className="ticket-follows-panel__sort" ref={followSortMenuRef}>
                                <button
                                    type="button"
                                    className="ticket-follows-panel__sort-btn"
                                    onClick={() => setIsFollowSortMenuOpen((previous) => !previous)}
                                    aria-haspopup="menu"
                                    aria-expanded={isFollowSortMenuOpen}
                                >
                                    <i className="bi bi-funnel me-1" aria-hidden="true" />
                                    Ordenar por: {followSortOrder === 'ASC' ? 'Más antiguo' : 'Más reciente'}
                                    <i className="bi bi-chevron-down ms-1" aria-hidden="true" />
                                </button>

                                {isFollowSortMenuOpen && (
                                    <div className="ticket-follows-panel__sort-menu" role="menu">
                                        <button
                                            type="button"
                                            className={`ticket-follows-panel__sort-option ${followSortOrder === 'DESC' ? 'is-active' : ''}`}
                                            onClick={() => handleSelectFollowSortOrder('DESC')}
                                        >
                                            Más reciente
                                        </button>
                                        <button
                                            type="button"
                                            className={`ticket-follows-panel__sort-option ${followSortOrder === 'ASC' ? 'is-active' : ''}`}
                                            onClick={() => handleSelectFollowSortOrder('ASC')}
                                        >
                                            Más antiguo
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>

                    {resolutionAttachments.length > 0 && (
                        <div className="mb-3">
                            <div className="fw-semibold fs-12 mb-2">Adjuntos de resolución</div>
                            <div className="d-flex flex-wrap gap-2">
                                {resolutionAttachments.map((file) => (
                                    <AttachmentContextTrigger
                                        key={file._id}
                                        file={file}
                                        isOpen={openAttachmentMenuId === file._id}
                                        onToggle={handleToggleAttachmentMenu}
                                        onDownload={handleDownloadAttachment}
                                        buttonClassName="btn btn-light-brand btn-sm"
                                        wrapperClassName="position-relative d-inline-block"
                                    />
                                ))}
                            </div>
                        </div>
                    )}

                    {visibleFollows.length === 0 && (
                        <div className="border rounded bg-light py-4 px-3 text-center mt-3">
                            <i className="bi bi-chat-left-dots d-block fs-3 mb-2 text-muted" aria-hidden="true" />
                            <div className="fw-semibold">{followEmptyMessage}</div>
                            <div className="text-muted fs-12">Cuando se agreguen notas, aparecerán aquí.</div>
                        </div>
                    )}

                    {visibleFollows.length > 0 && (
                        <div className="ticket-follows-list">
                            {visibleFollows.map((follow) => (
                                <div key={follow._id} className="ticket-follow-item">
                                    <UserAvatar
                                        name={follow.author?.name || follow.author?.email || 'Usuario'}
                                        photoUrl={getFollowAuthorAvatar(follow.author)}
                                        className="ticket-follow-avatar"
                                        fallbackClassName="ticket-follow-avatar ticket-follow-avatar--fallback"
                                    />

                                    <div className="ticket-follow-item__body">
                                        <div className="ticket-follow-item__header">
                                            <div className="d-flex align-items-center flex-wrap gap-2">
                                                <span className="ticket-follow-item__author">{follow.author?.name || follow.author?.email || 'Sin autor'}</span>
                                                <span className="ticket-follow-item__date">{formatDateTime(follow.createdDate)}</span>
                                            </div>

                                            <span className={`badge ${follow.isPublic ? 'bg-soft-success text-success' : 'bg-soft-warning text-warning'}`}>
                                                {follow.isPublic ? 'PÚBLICO' : 'PRIVADO'}
                                            </span>
                                        </div>

                                        <div className="ticket-html-content ticket-follow-item__content" dangerouslySetInnerHTML={{ __html: follow.contentHtml || '<p class="mb-0 text-muted">Sin contenido</p>' }} />

                                        {Array.isArray(followFilesById[follow._id]) && followFilesById[follow._id].length > 0 && (
                                            <div className="d-flex flex-wrap gap-2 mt-2">
                                                {followFilesById[follow._id].map((file) => (
                                                    <AttachmentContextTrigger
                                                        key={file._id}
                                                        file={file}
                                                        isOpen={openAttachmentMenuId === file._id}
                                                        onToggle={handleToggleAttachmentMenu}
                                                        onDownload={handleDownloadAttachment}
                                                        buttonClassName="btn btn-light-brand btn-sm"
                                                        wrapperClassName="position-relative d-inline-block"
                                                    />
                                                ))}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};